import type { SxProps, Theme } from '@mui/material'

export const styles = {
  root: {
    display: 'flex',
    flexDirection: 'column',
    gap: 0.5,
  },
  text: {
    color: 'text.secondary',
    overflow: 'hidden',
    overflowWrap: 'anywhere',
  },
  clamped: {
    display: '-webkit-box',
    WebkitBoxOrient: 'vertical',
    WebkitLineClamp: 3,
  },
  toggle: {
    alignSelf: 'flex-start',
    color: 'primary.main',
    fontWeight: 500,
    cursor: 'pointer',
    '&:hover': { textDecoration: 'underline' },
  },
} satisfies Record<string, SxProps<Theme>>
